/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import "css/touchpointManager.css";
import {
  Input,
  Tooltip,
  Table,
  Button,
  Form,
  Modal,
  Drawer,
  message,
} from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  updateTouchpoint,
  getTuchPointIdData,
  createTrackableLink,
  testJourneyTouchpoint,
} from "../../apiService/RESTApi";
import successIcon from "../../assets/Images/successIcon.svg";
import ContactSelector from "../../Components/Common/ContactSelector";
import { useActiveCompanyData, } from "hooks/CompanyHooks";

const { TextArea } = Input;
export default function TableView(props) {
  const { groups, roAdmin } = useSelector((state) => state.loginReducer);

  const [form] = Form.useForm();

  const [edit, setEdit] = useState(false);
  const [editJourney, setEditJourney] = useState(false);
  const [journeyState, setJourneyState] = useState('live');
  const [journeyData, setJourneyData] = useState({});
  const [touchPointForm, setTouchPointForm] = useState({});
  const [journeyForm, setJourneyForm] = useState({});
  const [touchpointBeingEdited, setTouchpointBeingEdited] = useState();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [touchpointLoading, setTouchpointLoading] = useState(false);
  const [isContactSelectorOpen, setIsContactSelectorOpen] = useState(false);
  const [isTouchpointSentModalOpen, setIsTouchpointSentModalOpen] = useState(false);
  const [testJourneyId, setTestJourneyId] = useState("");
  const [testTouchPointId, setTestTouchPointId] = useState("");
  const [journeyIdForSelectedTouchPoint, setJourneyIdForSelectedTouchPoint] = useState("");

    const activeCompanyData = useActiveCompanyData();

  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    if (row?.name === true) {
      obj.props.colSpan = 0;
    }
    return obj;
  };

  const columns = [
    {
      title: "Touchpoint Name",
      dataIndex: "Tname",
      key: "Tname",
      className: "touchpoint-name ",
      render: (text, row, index) => {
        let journey = row["journey"];
        var currentState = journey?.currentState ?? "";

        var journeyInfo = `Journey: ${text}`;
        if (currentState && currentState.effectiveDate && currentState.state) {
          journeyInfo += ` - (${currentState.state})`;
          setJourneyData(journey);
        }

        if (row?.name === true) {
          return {
            children: (
              <div className="name-wrapper p-16">
                <span style={{ color: "#124173", fontWeight: 600 }}>
                  {journeyInfo}
                </span>
              </div>
            ),
            props: {
              colSpan: 4,
            },
          };
        }
        return <span className="p-16 d-block">{text}</span>;
      },
    },

    {
      title: "Trigger/Timing",
      dataIndex: "type",
      key: "type",
      className: "p-16",
      render: renderContent,
    },

    {
      title: "Message",
      key: "msg",
      dataIndex: "msg",
      className: "p-16",
      render: renderContent,
    },
    {
      title: "Links",
      key: "link",
      dataIndex: "link",
      className: "p-16",
      render: renderContent,
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: "edit-journey-name",
      width: 80,
      render: (text, row, index) => {
        if (row.name === true) {
          return {
            children: (
              <div className="edit-journey-wrapper">
                <Button
                  disabled={roAdmin}
                  type="text"
                  style={{ color: "#959595" }}
                  onClick={() => handleEditJourney(row)}
                >
                  <EditOutlined style={{ fontSize: "20px" }} />
                </Button>
              </div>
            ),
          }
        }
        return <span className="p-16 d-block">{text}</span>;
      }
    },
  ];

  const handleEdit = (data, item) => {
    let temp = { ...touchPointForm };
    temp["id"] = data?.id !== undefined && data?.id;
    temp["ordinal"] = data.ordinal !== undefined && data?.ordinal;
    temp["wait"] =
      data?.wait !== undefined && (data?.wait || "Immediate on insert");
    temp["name"] = data?.name !== undefined && data?.name;
    temp["messageContent"] =
      data?.messageContent !== undefined && data?.messageContent;
    temp["messageTemplateName"] =
      data?.messageTemplateName !== undefined && data?.messageTemplateName;
    temp["contentLinkToTrackableLink"] =
      data?.contentLinkToTrackableLink !== undefined &&
      data?.contentLinkToTrackableLink !== null
        ? Object.keys(data?.contentLinkToTrackableLink)
        : "";
    setTouchpointBeingEdited(data?.id);
    setJourneyIdForSelectedTouchPoint(item?.id);
    form.setFieldsValue(temp);
    setTouchPointForm(temp);

    setEdit(true);
  };

  const handleEditJourney = (item) => {
    let journey = item["journey"];
    let temp = { ...journeyForm };
    temp["journeyName"] = journey.name;
    temp["journeyId"] = journey.id;
    temp["currentState"] = journey.currentState?.state;

    form.setFieldsValue(temp);
    setJourneyForm(temp);
    setState(journey.currentState?.state.toLowerCase());
    setEditJourney(true);
  };

  const onClose = () => {
    if (edit === true) {
      setEdit(false);
    } else  {
      setEditJourney(false);
      setState(journeyData.currentState?.state.toLowerCase());
    }
  };

    /**
    * NOTE!!!
    *
    * The value passed in to this function is confusing to follow:
    * 
    * trackableLinkData has been coded in a higher scope to be 
    * if new value: string (ie. `trackableLinkData: "https://blustream.io"`)
    * if already tracked: array (ie. `trackableLinkData: ["https://blustream.io"]`)
    * 
    * When the link gets urlEncoded it always gets converted to a string
    * 
    * -----
    * 
    * When to call this function is confusing:
    * 
    * The higher scope is not tracking the linkCode 
    * So even when we are not updating the link value, the call to this API is 
    * still required to carry forward the code for the tracked link
    * 
    */
    const updateTrackableLink = async (trackableLinkData) => {

        let linkToTrack = encodeURIComponent(trackableLinkData);
        if (linkToTrack === "" || linkToTrack === undefined || linkToTrack === null) {
            // No link to track
            return null;
        }

        return await createTrackableLink(
            activeCompanyData?.databaseId,
            linkToTrack,
            touchpointBeingEdited
        )
            .then((linkTrackerResponse) => {
                const linkTrackerResponseBody = linkTrackerResponse?.response;

                // Print errors
                if (linkTrackerResponseBody?.errors != null) {
                    throw new Error("Failed to update trackable link: " + linkTrackerResponseBody?.errors);
                }

                const trackableLinkResponseData = linkTrackerResponseBody?.data?.[0];
                if (trackableLinkResponseData && trackableLinkResponseData.length >= 2) {
                    // Grab link code
                    let newLinkCode = trackableLinkResponseData[0]; // example: {"data": [["WF0YEE","https://bstrm.io/L/WF0YEE/{{Id}}"]]}
                    return newLinkCode;
                } else {
                    throw new Error("Trackable Link Response Body Missing Data: " + linkTrackerResponseBody);
                }

            })
            .catch((error) => {
                message.error("Failed to create trackable link. Please try again.");
                throw error;
            });
    }

    const handleSaveTouchpoint = async () => {
        try {
            // Set Loading UI State
            setTouchpointLoading(true);

            // Merge form data with existing touchpoint data
            let touchpointDataToSave = { ...touchPointForm, ...form.getFieldsValue() };

            // sync data
            setTouchPointForm(touchpointDataToSave); 

            // Extract trackable link and remove from payload
            const trackableLinkData = touchpointDataToSave?.contentLinkToTrackableLink
            delete touchpointDataToSave?.contentLinkToTrackableLink;

            // Update or get the trackable link code
            touchpointDataToSave.linkCode = await updateTrackableLink(trackableLinkData);

            // Update the touchpoint
            return await updateTouchpoint(
                activeCompanyData?.uuid,
                journeyIdForSelectedTouchPoint,
                touchpointBeingEdited,
                touchpointDataToSave
            )
            .then(() => {
                getTableIdData(); // Update the data in the main table
                setEdit(false); // Close the edit drawer
            })
            .catch((error) => {
                message.error("Touchpoint failed to save. Please try again.");
                throw error;
            });
        }
        catch (error) {
            console.error("Failed to update touchpoint:", error);
        }
        finally {
            setTouchpointLoading(false);
        }
    };

  const getTableIdData = async () => {
    if (props.journeyId !== undefined) {
      setLoading(true);

      await getTuchPointIdData(groups[0], props?.journeyId)
        .then((res) => {
          let temp = [];
          Promise.all(
            res?.response?.data?.map((item, index) => {
              temp.push({ Tname: item?.name, name: true, journey: item });
              item?.touchpoints?.map((value) => {
                return temp.push({
                  key: value?.id !== undefined ? value.id : "",
                  journeyId: item.id,
                  Tname: (
                    <>
                      <p>
                        {value?.messageTemplateName !== undefined
                          ? value?.messageTemplateName
                          : ""}
                      </p>
                      <button
                        disabled={roAdmin}
                        style={{
                          textDecoration: "underline",
                          fontStyle: "italic",
                          color: "#F37064",
                          cursor: "pointer",
                          border: "none",
                          background: "none",
                        }}
                        onClick={() => onTestNowClicked(item?.id, value.id)}
                      >
                        Test now
                      </button>
                    </>
                  ),
                  edit: (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <Button
                        disabled={roAdmin}
                        type="text"
                        style={{ color: "#959595" }}
                        onClick={() => handleEdit(value, item)}
                      >
                        <EditOutlined style={{ fontSize: "20px" }} />
                      </Button>
                    </div>
                  ),
                  type: (
                    <p>
                      {value?.wait !== undefined &&
                      value?.wait !== null &&
                      value.wait !== ""
                        ? moment.duration(value?.wait).asDays() >= 1
                          ? `After ${moment
                              .duration(value?.wait)
                              .asDays()} days to previous`
                          : `After ${moment
                              .duration(value?.wait)
                              .asHours()} hours to previous`
                        : "Immediate on insert"}
                    </p>
                  ),
                  msg:
                    value?.messageContent !== undefined ? (
                      <pre
                        style={{
                          whiteSpace: "break-spaces",
                          fontFamily: "Hellix",
                        }}
                      >
                        {value?.messageContent}
                      </pre>
                    ) : (
                      ""
                    ),
                  link:
                    value?.contentLinkToTrackableLink !== undefined &&
                    value?.contentLinkToTrackableLink !== null ? (
                      <a
                        href={Object.keys(value?.contentLinkToTrackableLink)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {Object.keys(value?.contentLinkToTrackableLink)}
                      </a>
                    ) : (
                      ""
                    ),
                });
              });
            })
          )
            .then((res) => {
              setTableData(temp);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getTableIdData();
  }, [props?.journeyId]);

  const selectContactsHandleOk = async (selectedContacts) => {
    setLoading(true);
    // eslint-disable-next-line
    const testTouchpointResponses = await selectedContacts.map(async (contactId) => {
      const response = await testJourneyTouchpoint(contactId, testJourneyId, testTouchPointId);
      
      // TODO show some UI based on the list of responses
      /*
        {
          response: {
            status: -1,
            errors: null,
            data: [
              "In TouchpointSentStatusWriterBase.getContactJourneyTouchpointInstanceDto(ContactDto contactDto, PinpointJourneyDto pinpointJourneyDto): Contact 2871 is not on journey 474",
            ],
            startRow: null,
            endRow: null,
            totalRows: null,
          },
        }
      */

      return response;
    });

    setLoading(false);
  };

  const selectContactsHandleCancel = () => {
  };

  const onTestNowClicked = (journeyId, touchpointId) => {
    setIsContactSelectorOpen(true);
    setTestJourneyId(journeyId);
    setTestTouchPointId(touchpointId);
  };

  useEffect(() => {
    if (journeyData) {
      const currentState = journeyData.currentState?.state?.toLowerCase();
      if (currentState) {
        return currentState;
      }
    }
  }, [journeyData]);

  const setState = (newState) => {
    setJourneyState(newState);
  };

  return (
    <>
      <div className="tableView">
        <Table
          className="journey-table"
          columns={columns}
          loading={loading}
          pagination={false}
          tableLayout="fixed"
          bordered
          dataSource={tableData}
          scroll={{ y: 450 }}
        />
        <Drawer
          width={430}
          title="Edit Journey"
          placement="right"
          onClose={onClose}
          open={editJourney}
        >
          <Form
              form={form}
              layout="vertical"
              className="edit-journey-form"
              style={{paddingBottom: 60}}
          >
            <Form.Item
                label="Journey Name"
                style={{width: "100%"}}
                name="journeyName"
            >
              <Input
                  className="standard-input"
                  disabled={true}
                  placeholder="Enter Journey Name"
              />
            </Form.Item>
            <Form.Item
                label={
                  <Tooltip
                      placement="rightBottom"
                      title={
                        <>
                          <strong>Live:</strong> Sending messages to all eligible contacts.<br/>
                          <strong>Muted:</strong> Continue the journey's schedule but silence all outbound messages and
                          responses.<br/>
                          <strong>Paused:</strong> Temporarily stop the schedule and resume from current position when
                          you leave this state.<br/>
                          <strong>Disabled:</strong> Stop all messaging and reset all journeys. Journeys will restart
                          from the beginning for all eligible contacts when resuming.
                        </>
                      }
                  >
                    <div style={{display: "flex", alignItems: "center"}}>
                      <div>State</div>
                      <InfoCircleOutlined style={{paddingLeft: "3px"}}/>
                    </div>
                  </Tooltip>
                }
                style={{width: "100%"}}
                name="messageContent"
                type="textarea"
            >
              <div className="journey-state-switcher">
                {/*added disabled class and commented onClick function to avoid the clicking behavior but still able to hover the buttons.*/}
                <Button
                    className={`disabled journey-state-button ant-btn ant-btn-secondary standard-button ${journeyState === 'live' ? "active primary-orange-button" : ""}`}
                    /*onClick={() => setState('live')}*/>Live</Button>
                  <Button
                      className={`disabled journey-state-button ant-btn ant-btn-secondary standard-button ${journeyState === 'muted' ? "active primary-orange-button" : ""}`}
                      /*onClick={() => setState('muted')}*/>Muted</Button>
                <Button
                    className={`disabled journey-state-button ant-btn ant-btn-secondary standard-button ${journeyState === 'paused' ? "active primary-orange-button" : ""}`}
                    /*onClick={() => setState('paused')}*/>Paused</Button>
                <Button
                    className={`disabled journey-state-button ant-btn ant-btn-secondary standard-button ${journeyState === 'disabled' ? "active primary-orange-button" : ""}`}
                    /*onClick={() => setState('disabled')}*/>Disabled</Button>
              </div>
            </Form.Item>
            {/* } */}
            <div className="action-buttons-wrapper">
              <Button
                  className="standard-button tertiary-button"
                  style={{marginRight: 8, width: "48%"}}
                  size="middle"
                  onClick={onClose}
              >
              Cancel
              </Button>
              <Button
                  type="primary"
                  style={{width: "48%"}}
                  htmlType="submit"
                  className="standard-button primary-orange-button"
                  size="middle"
                  // loading={touchpointLoading}
              >
                Save
              </Button>
            </div>
          </Form>
        </Drawer>

        <Drawer
            width={430}
            title="Edit touchpoint details"
            placement="right"
            onClose={onClose}
            open={edit}
        >
          <Form
              form={form}
              layout="vertical"
              className="edit-touchpoint-form"
            style={{ paddingBottom: 60 }}
            onFinish={handleSaveTouchpoint}
          >
            <Form.Item
              label="Touchpoint Name"
              style={{ width: "100%" }}
              name="messageTemplateName"
            >
              <Input
                className="standard-input"
                disabled={true}
                placeholder="Enter Touchpoint Name"
              />
            </Form.Item>
            <Form.Item
              label="Trigger/Timing"
              style={{ width: "100%" }}
              name="wait"
            >
              <Input className="standard-input" disabled={true} />
            </Form.Item>
            <Form.Item
              label={
                <Tooltip
                  placement="rightBottom"
                  title="To insert the link from the field below into the message, add {{LINK}} to the message’s text."
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div>Message</div>
                    <InfoCircleOutlined style={{ paddingLeft: "3px" }} />
                  </div>
                </Tooltip>
              }
              style={{ width: "100%" }}
              name="messageContent"
              type="textarea"
            >
              <TextArea
                autoSize={{ minRows: 2, maxRows: 6 }}
                placeholder="Enter Message"
              />
            </Form.Item>
            <Form.Item
              label={
                <Tooltip
                  placement="rightBottom"
                  title="Links added here become trackable automatically."
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div>Link</div>
                    <InfoCircleOutlined style={{ paddingLeft: "3px" }} />
                  </div>
                </Tooltip>
              }
              style={{ width: "100%" }}
              name="contentLinkToTrackableLink"
            >
              <Input className="standard-input" placeholder="Enter Link" />
            </Form.Item>
            {/* } */}
            <div className="action-buttons-wrapper">
              <Button
                className="standard-button tertiary-button"
                style={{ marginRight: 8, width: "48%" }}
                size="middle"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                style={{ width: "48%" }}
                htmlType="submit"
                className="standard-button primary-orange-button"
                size="middle"
                loading={touchpointLoading}
              >
                Save
              </Button>
            </div>
          </Form>
        </Drawer>
      </div>
      <ContactSelector
        isOpen={isContactSelectorOpen}
        toggleModal={() => setIsContactSelectorOpen(!isContactSelectorOpen)}
        allowMultipleSelection={true}
        footerText={`Clicking Start Journey will start the selected customers on a journey. This action may trigger future messages.`}
        buttonText="Start Journey"
        onOkCallback={selectContactsHandleOk}
        onCancelCallback={selectContactsHandleCancel}
      />
      <Modal
        open={isTouchpointSentModalOpen}
        onCancel={() => setIsTouchpointSentModalOpen(false)}
        footer={null}
        centered
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "30px 40px",
            gap: "22px",
          }}
        >
          <img src={successIcon} alt="" />
          <p
            style={{
              fontWeight: "600",
              fontSize: "22px",
              lineHeight: "30px",
              color: "#252525",
            }}
          >
            Touchpoint Sent !
          </p>
        </div>
      </Modal>
    </>
  );
}
